import { Link } from "react-router-dom";
import { Video, Package } from "lucide-react";

export const AuctionMedia = ({ auction, listing, lotListings }) => (
  <>
    <div className="glass-card overflow-hidden mb-6">
      <div className="relative h-80 md:h-96 bg-[#18181B]">
        {listing.photos?.[0] ? (
          <img src={listing.photos[0]} alt={listing.title} className="w-full h-full object-cover" />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-6xl">🐴</div>
        )}
      </div>

      {listing.photos?.length > 1 && (
        <div className="flex gap-2 p-4 overflow-x-auto">
          {listing.photos.map((photo) => (
            <img
              key={photo}
              src={photo}
              alt=""
              className="w-16 h-16 rounded object-cover border border-[#27272A]"
            />
          ))}
        </div>
      )}
    </div>

    {auction.video_url && (
      <div className="glass-card overflow-hidden mb-6" data-testid="auction-video">
        <div className="flex items-center gap-2 p-4 pb-2">
          <Video className="w-4 h-4 text-blue-400" />
          <span className="text-sm text-[#A1A1AA]">Video Showcase</span>
        </div>
        <div className="aspect-video">
          <iframe
            src={auction.video_url
              .replace("watch?v=", "embed/")
              .replace("youtu.be/", "youtube.com/embed/")
              .replace("vimeo.com/", "player.vimeo.com/video/")}
            className="w-full h-full"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            title="Auction Video"
          />
        </div>
      </div>
    )}

    {auction.is_lot && lotListings.length > 0 && (
      <div className="glass-card p-6 mb-6" data-testid="auction-lot-items">
        <div className="flex items-center gap-2 mb-4">
          <Package className="w-5 h-5 text-[#D4AF37]" />
          <h3 className="text-lg text-[#EDEDED]">
            {auction.lot_title || `Lot of ${1 + lotListings.length} items`}
          </h3>
        </div>
        <p className="text-xs text-[#71717A] mb-3">
          This auction includes the primary listing plus the following items. One bid covers the entire lot.
        </p>
        <div className="space-y-2">
          {lotListings.map((item) => (
            <Link
              key={item.listing_id}
              to={`/listing/${item.listing_id}`}
              className="flex items-center gap-3 p-3 rounded-lg bg-[#0A0A0A] hover:bg-[#18181B] transition-colors"
            >
              <img
                src={item.photos?.[0] || "https://via.placeholder.com/60"}
                alt={item.title}
                className="w-12 h-12 rounded object-cover"
              />
              <div className="flex-1 min-w-0">
                <p className="text-sm text-[#EDEDED] truncate">{item.title}</p>
                <p className="text-xs text-[#71717A] capitalize">
                  {item.species} {item.breed ? `• ${item.breed}` : ""}
                </p>
              </div>
              <span className="text-sm text-[#D4AF37]">${item.price?.toLocaleString()}</span>
            </Link>
          ))}
        </div>
      </div>
    )}
  </>
);

export const ListingInfo = ({ listing }) => (
  <div className="glass-card p-6">
    <div className="flex items-center gap-2 mb-3">
      <span className="px-2 py-1 bg-[#27272A] text-[#A1A1AA] rounded text-sm capitalize">
        {listing.species}
      </span>
      {listing.breed && (
        <span className="px-2 py-1 bg-[#18181B] text-[#71717A] rounded text-sm">{listing.breed}</span>
      )}
    </div>

    <h1 className="text-2xl text-[#EDEDED] mb-4">{listing.title}</h1>

    {listing.description && <p className="text-[#A1A1AA] mb-6">{listing.description}</p>}

    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      {listing.age && (
        <div>
          <p className="text-xs text-[#71717A]">Age</p>
          <p className="text-[#EDEDED]">{listing.age}</p>
        </div>
      )}
      {listing.sex && (
        <div>
          <p className="text-xs text-[#71717A]">Sex</p>
          <p className="text-[#EDEDED] capitalize">{listing.sex}</p>
        </div>
      )}
      {listing.location_state && (
        <div>
          <p className="text-xs text-[#71717A]">Location</p>
          <p className="text-[#EDEDED]">
            {listing.location_city}, {listing.location_state}
          </p>
        </div>
      )}
      {listing.registry_organization && (
        <div>
          <p className="text-xs text-[#71717A]">Registry</p>
          <p className="text-[#EDEDED]">{listing.registry_organization}</p>
        </div>
      )}
    </div>
  </div>
);
